import { render, staticRenderFns } from "./StockListaItem.vue?vue&type=template&id=7816cb55&"
import script from "./StockListaItem.vue?vue&type=script&lang=js&"
export * from "./StockListaItem.vue?vue&type=script&lang=js&"
import style0 from "./StockListaItem.vue?vue&type=style&index=0&id=7816cb55&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports